import {
  Box,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select as MuiSelect,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { PrintRounded } from "@mui/icons-material";
import { spacing } from "@mui/system";
import axios from "axios";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Select = styled(MuiSelect)(spacing);
const TextField = styled(MuiTextField)(spacing);

export default (props) => {
  const [useServiceAddress, setUseServiceAddress] = React.useState(true);
  const editData = props.editData;
  const onFieldChange = props.onFieldChange;
  const moveIn = props.moveIn;
  const action = props.action;
  const handleClose = props.handleClose;
  const properties = props.properties.data.propertiesList.items;
  const onFieldCheckboxChange = props.onFieldCheckboxChange;

  let readTypeCheckedInitialState = "";

  if (moveIn.readAmtType == "EST") readTypeCheckedInitialState = "EST";
  if (moveIn.readAmtType == "ACT") readTypeCheckedInitialState = "ACT";

  const [units, setUnits] = useState([]);
  const [areUnitsLoading, setAreUnitsLoading] = useState(false);
  const unitsFetchSeq = useRef(0);
  const [unitMeters, setUnitMeters] = useState([]);
  const onMeterReadChange = props.onMeterReadChange;

  const [readTypeChecked, setReadTypeChecked] = useState(
    readTypeCheckedInitialState
  );

  const handleUseServiceAddressChange = (event) => {
    onFieldCheckboxChange(event);
    if (useServiceAddress) {
      setUseServiceAddress(false);
    }
    else {
      setUseServiceAddress(true);
    }
  };

  const handleReadTypeChange = (type) => {
    if (readTypeChecked == type) setReadTypeChecked("");
    else setReadTypeChecked(type);
  };

  const isUsingServiceAddress = () => {
    if (moveIn.serviceAddress == moveIn.address1) {
      return true;
    }
    else {
      return false;
    }
  };

  useEffect(() => {
    if (isEmpty(moveIn)) return;
    if (!isUsingServiceAddress()) {
      setUseServiceAddress(false);
    }
  }, [moveIn?.uuid, moveIn?.serviceAddress, moveIn?.address1]);

  // Re-fetch units when the properties list becomes available or when switching moves.
  // Sequence ref drops stale axios responses when the user opens another edit quickly.
  useEffect(() => {
    if (isEmpty(moveIn) || !moveIn.propertyUuid) return;
    if (!properties || !properties.length) return;
    const ind = properties.findIndex((elem) => elem.uuid == moveIn.propertyUuid);
    if (ind === -1) return;
    const propertyId = properties[ind].id;
    const seq = ++unitsFetchSeq.current;
    setUnits([]);
    setAreUnitsLoading(true);
    axios
      .get(`/unit/property/${propertyId}`)
      .then((res) => {
        if (seq !== unitsFetchSeq.current) return;
        setUnits(Array.isArray(res.data) ? res.data : []);
        setAreUnitsLoading(false);
      })
      .catch((err) => {
        if (seq !== unitsFetchSeq.current) return;
        console.log(err);
        setAreUnitsLoading(false);
      });
  }, [moveIn?.uuid, moveIn?.propertyUuid, properties?.length]);

  useEffect(() => {
    if (isEmpty(moveIn) || !moveIn.unitUuid) {
      setUnitMeters([]);
      return;
    }
    axios
      .get(`/unit/${moveIn.unitUuid}/meter`)
      .then((res) => {
        const meters = Array.isArray(res.data) ? res.data : res.data?.meters || [];
        setUnitMeters(meters);
      })
      .catch(() => setUnitMeters([]));
  }, [moveIn?.uuid, moveIn?.unitUuid]);

  const extraMeters = unitMeters.filter((meter) => String(meter.id) !== String(moveIn.meterId));

  //console.log("move in: ", moveIn);
  //console.log("useEffect move in edit form");
  //console.log(moveIn);
  return (
    <div>
      {isEmpty(moveIn) ? (
        <div>Loading</div>
      ) : (
        <Card>
          <CardContent sx={{ p: 2 }}>
            {/* PropertyManager Details */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                  Contact Information
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <TextField
                      label="First Name"
                      type="text"
                      onChange={onFieldChange}
                      name="firstName"
                      defaultValue={moveIn.firstName}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <TextField
                      label="Last Name"
                      type="text"
                      onChange={onFieldChange}
                      name="lastName"
                      defaultValue={moveIn.lastName}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 8px)' } }}>
                    <TextField
                      label="SSN"
                      type="password"
                      onChange={onFieldChange}
                      name="ssn"
                      defaultValue={moveIn.ssn}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <TextField
                      label="Email"
                      type="text"
                      onChange={onFieldChange}
                      name="email"
                      defaultValue={moveIn.email}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Box>
              </Paper>
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                  Phone Numbers
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <TextField
                      label="Phone 1"
                      type="text"
                      onChange={onFieldChange}
                      name="phone1"
                      defaultValue={moveIn.phone1}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <TextField
                      label="Phone 2"
                      type="text"
                      onChange={onFieldChange}
                      name="phone2"
                      defaultValue={moveIn.phone2}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Box>
              </Paper>

              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                  Preferences
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={moveIn.eBills ? true : false}
                        onChange={onFieldCheckboxChange}
                        name="eBills"
                        value="E-Bills"
                      />
                    }
                    label="E-Bills"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={moveIn.printedBills ? true : false}
                        onChange={onFieldCheckboxChange}
                        name="printedBills"
                        value="Print Bills"
                      />
                    }
                    label="Print Bills"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked={moveIn.userAccountExists ? true : false}
                        onChange={onFieldCheckboxChange}
                        name="userAccountExists"
                        value="User Exists"
                      />
                    }
                    label="User Exists"
                  />
                </Box>
              </Paper>

              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                  Unit Information
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="edit-movein-property-label">Property</InputLabel>
                      {properties.length > 0 ? (
                      <Select
                        key={`property-${moveIn.uuid}-${properties.length}`}
                        labelId="edit-movein-property-label"
                        id="propertyUuid"
                        label="Property"
                        onChange={onFieldChange}
                        defaultValue={moveIn.propertyUuid ?? ""}
                        name="propertyUuid"
                        variant="outlined"
                      >
                        <MenuItem value="">All</MenuItem>
                        {properties.map((item, key) => (
                          <MenuItem value={item.uuid} key={key}>{item.name}</MenuItem>
                        ))}
                      </Select>
                      ) : (
                      <Select
                        key={`property-${moveIn.uuid}-empty`}
                        labelId="edit-movein-property-label"
                        id="propertyUuid"
                        label="Property"
                        disabled
                        defaultValue=""
                        variant="outlined"
                      >
                        <MenuItem value="">No properties loaded</MenuItem>
                      </Select>
                      )}
                    </FormControl>
                  </Box>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="edit-movein-unit-label">Unit</InputLabel>
                      {units && units.length ? (
                        <Select
                          key={`unit-${moveIn.uuid}-${units.length}`}
                          labelId="edit-movein-unit-label"
                          id="unitUuid"
                          label="Unit"
                          onChange={onFieldChange}
                          defaultValue={moveIn.unitUuid ?? ""}
                          name="unitUuid"
                          variant="outlined"
                        >
                          {units.map((item, index) => {
                            let address2 = !item.address2 ? "" : item.address2;
                            return (
                              <MenuItem value={item.uuid} key={index}>
                                {item.address1 + address2}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      ) : (
                        <Select
                          labelId="edit-movein-unit-label"
                          id="unitUuid"
                          label="Unit"
                          disabled
                          defaultValue=""
                          variant="outlined"
                        >
                          <MenuItem value="">
                            {areUnitsLoading ? "Loading units…" : "No units available"}
                          </MenuItem>
                        </Select>
                      )}
                    </FormControl>
                  </Box>
                </Box>
              </Paper>
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                  Address Information
                </Typography>
                <Box sx={{ mb: 1.5 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={useServiceAddress}
                        onChange={handleUseServiceAddressChange}
                        name="serviceAddressSame"
                      />
                    }
                    label="Use service address as contact and billing info"
                  />
                </Box>
                
                {!useServiceAddress && (
                  <>
                    <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 500, mt: 2, mb: 1 }}>
                      Mailing Address
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
                      <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                        <TextField
                          label="Address Line 1"
                          type="text"
                          onChange={onFieldChange}
                          name="address1"
                          defaultValue={moveIn.address1}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                        <TextField
                          label="Address Line 2"
                          type="text"
                          onChange={onFieldChange}
                          name="address2"
                          defaultValue={moveIn.address2}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                        <TextField
                          label="City"
                          type="text"
                          onChange={onFieldChange}
                          name="city"
                          defaultValue={moveIn.city}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: { xs: '1 1 50%', sm: '1 1 calc(20% - 8px)' } }}>
                        <TextField
                          label="State"
                          type="text"
                          onChange={onFieldChange}
                          name="state"
                          defaultValue={moveIn.state}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: { xs: '1 1 50%', sm: '1 1 calc(30% - 8px)' } }}>
                        <TextField
                          label="ZIP Code"
                          type="text"
                          onChange={onFieldChange}
                          name="zip"
                          defaultValue={moveIn.zip}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                    </Box>

                    <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 500, mt: 2, mb: 1 }}>
                      Billing Address
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                      <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                        <TextField
                          label="Billing Address Line 1"
                          type="text"
                          onChange={onFieldChange}
                          name="billingAddress1"
                          defaultValue={moveIn.billingAddress1}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                        <TextField
                          label="Billing Address Line 2"
                          type="text"
                          onChange={onFieldChange}
                          name="billingAddress2"
                          defaultValue={moveIn.billingAddress2}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                        <TextField
                          label="Billing City"
                          type="text"
                          onChange={onFieldChange}
                          name="billingCity"
                          defaultValue={moveIn.billingCity}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: { xs: '1 1 50%', sm: '1 1 calc(20% - 8px)' } }}>
                        <TextField
                          label="Billing State"
                          type="text"
                          onChange={onFieldChange}
                          name="billingState"
                          defaultValue={moveIn.billingState}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: { xs: '1 1 50%', sm: '1 1 calc(30% - 8px)' } }}>
                        <TextField
                          label="Billing ZIP Code"
                          type="text"
                          onChange={onFieldChange}
                          name="billingZip"
                          defaultValue={moveIn.billingZip}
                          fullWidth
                          variant="outlined"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>
                    </Box>
                  </>
                )}
              </Paper>
              <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ color: 'primary.main', fontWeight: 600, mb: 1.5 }}>
                  Move Information
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <TextField
                      label="Move In Date"
                      type="date"
                      onChange={onFieldChange}
                      name="moveInDate"
                      defaultValue={moment.utc(moveIn.moveInDate).format("YYYY-MM-DD")}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                    <TextField
                      label={moveIn.meterNum ? `Meter #${moveIn.meterNum} reading` : "Meter Reading"}
                      type="text"
                      onChange={onFieldChange}
                      name="meterRead"
                      defaultValue={moveIn.meterRead}
                      fullWidth
                      variant="outlined"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <Box sx={{ mt: 1.5 }}>
                      {moveIn.meterRead != 0 ? (
                        <Box sx={{ display: 'flex', gap: 2 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={readTypeChecked == "ACT"}
                                onChange={(e) => {
                                  handleReadTypeChange("ACT");
                                  onFieldChange(e);
                                }}
                                name="readAmtType"
                                value="ACT"
                                color="primary"
                              />
                            }
                            label="Actual Reading"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={readTypeChecked == "EST"}
                                onChange={(e) => {
                                  handleReadTypeChange("EST");
                                  onFieldChange(e);
                                }}
                                name="readAmtType"
                                value="EST"
                                color="primary"
                              />
                            }
                            label="Estimated Reading"
                          />
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', gap: 2 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={readTypeChecked == "ACT"}
                                onChange={(e) => {
                                  handleReadTypeChange("ACT");
                                  onFieldChange(e);
                                }}
                                disabled
                                name="readAmtType"
                                value="ACT"
                                color="primary"
                              />
                            }
                            label="Actual Reading"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={readTypeChecked == "EST"}
                                disabled
                                onChange={(e) => {
                                  handleReadTypeChange("EST");
                                  onFieldChange(e);
                                }}
                                name="readAmtType"
                                value="EST"
                                color="primary"
                              />
                            }
                            label="Estimated Reading"
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                  {extraMeters.map((meter) => (
                    <Box key={meter.id} sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                      <TextField
                        label={`Meter #${meter.meterNum} reading`}
                        type="number"
                        onChange={(e) => onMeterReadChange && onMeterReadChange(meter.id, e.target.value)}
                        name={`meterReads.${meter.id}`}
                        defaultValue={
                          moveIn.secondMeter && String(moveIn.secondMeter.meterId) === String(meter.id)
                            ? moveIn.secondMeter.meterRead
                            : ""
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              </Paper>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    action();
                    handleClose();
                  }}
                  size="medium"
                  sx={{ minWidth: 100 }}
                >
                  Save Changes
                </Button>
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
